// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"810":"603cc2a3","1623":"91f7ba47","5543":"603cc2a3","5576":"9687ae4b","7379":"85a30cbf","8366":"603cc2a3","8578":"def129a8"}[chunkId] + ".chunk.css";
};